import { API_ROUTES } from '@utils/apiRoutes';
import { ApiService } from '@utils/apiService';
import { Injectable, inject } from '@angular/core';

import { responseDAO } from '@app/interfaces/requests.dao';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiService = inject(ApiService)

  initSesion(body: any) {
    return this.apiService.post<responseDAO>(API_ROUTES.auth.routes.login, body)
  };
}
